// extracted by mini-css-extract-plugin
export default {"buttonsfooter":"info-modal_buttonsfooter__n2tuY"};